module.exports = __webpack_public_path__ + "img/ic_food_marketing.84ea0ce4.png";